import React from "react";
import WhyChooseCarousel, {
  toWhyChooseReasons,
} from "../../components/WhyChooseCarousel";
import { whyChooseContent } from "./isoContent";

/* Same strip the Home page uses, so the question reads identically wherever it
   is asked. These reasons come from this page's approved document as bare
   lines, so they borrow the shared illustrations positionally. */
const IsoWhyChoose = () => (
  <WhyChooseCarousel
    id="iso-why-choose-heading"
    title={whyChooseContent.title}
    reasons={toWhyChooseReasons(whyChooseContent.reasons)}
    tone="muted"
  />
);

export default IsoWhyChoose;
